import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
                妖精漫画
              </Link>
              <p className="mt-4 text-sm text-secondary-300 leading-relaxed">
                免费在线观看海量韩国漫画，下拉式韩漫大全。如同一个线上漫画博物馆，任您游览探索。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">全部漫画</Link></li>
                <li><Link to="/category/romance" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">恋爱漫画</Link></li>
                <li><Link to="/category/action" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">热血漫画</Link></li>
                <li><Link to="/category/fantasy" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">奇幻漫画</Link></li>
                <li><Link to="/category/mystery" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">悬疑漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
              <ul className="space-y-2.5">
                <li><Link to="/manga/tianming-zhi-zi" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">天命之子</Link></li>
                <li><Link to="/manga/an-ying-lie-ren" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">暗影猎人</Link></li>
                <li><Link to="/manga/chongsheng-wei-wang" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">重生为王</Link></li>
                <li><Link to="/manga/duru-nvwang-de-shenshi" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">独步女王的绅士</Link></li>
                <li><Link to="/manga/mishi-zhi-cheng" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">迷失之城</Link></li>
                <li><Link to="/manga/shen-jian-chuan-shuo" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">神剑传说</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
                <li><a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">用户协议</a></li>
                <li><a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">隐私政策</a></li>
                <li><a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">版权声明</a></li>
                <li><a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">帮助中心</a></li>
              </ul>
              <div className="mt-5">
                <p className="text-sm text-secondary-300">联系邮箱</p>
                <a href="mailto:contact@yaojingmanhua.com" className="text-sm text-primary-400 hover:text-primary-300 transition-colors">
                  contact@yaojingmanhua.com
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-400">
              &copy; {currentYear} 妖精漫画. All rights reserved.
            </p>
            <p className="text-sm text-secondary-400">
              本站所有漫画资源均来自互联网，仅供学习交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}